import { render, staticRenderFns } from "./PersonalDataDemo.vue?vue&type=template&id=4a713e60&scoped=true"
import script from "./PersonalDataDemo.vue?vue&type=script&lang=js"
export * from "./PersonalDataDemo.vue?vue&type=script&lang=js"
import style0 from "./PersonalDataDemo.vue?vue&type=style&index=0&id=4a713e60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a713e60",
  null
  
)

export default component.exports